function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 19.5C19.5 19.7652 19.3946 20.0196 19.2071 20.2071C19.0196 20.3947 18.7652 20.5 18.5 20.5H4.5C4.23478 20.5 3.98043 20.3947 3.79289 20.2071C3.60536 20.0196 3.5 19.7652 3.5 19.5V10.5H0.5L10.827 1.11201C11.0111 0.944489 11.2511 0.851654 11.5 0.851654C11.7489 0.851654 11.9889 0.944489 12.173 1.11201L22.5 10.5H19.5V19.5ZM7 12.5C7 13.6935 7.47411 14.8381 8.31802 15.682C9.16193 16.5259 10.3065 17 11.5 17C12.6935 17 13.8381 16.5259 14.682 15.682C15.5259 14.8381 16 13.6935 16 12.5H14C14 13.1631 13.7366 13.7989 13.2678 14.2678C12.7989 14.7366 12.163 15 11.5 15C10.837 15 10.2011 14.7366 9.73223 14.2678C9.26339 13.7989 9 13.1631 9 12.5H7Z",
  fill: "#CF5285"
});

function SvgAccueilOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccueilOn);
export default __webpack_public_path__ + "static/media/accueil-on.8bf4365146962aee04252ea46d485662.svg";
export { ForwardRef as ReactComponent };